// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import styled from "styled-components";

export const StyledP = styled.p`
  padding: 1rem 1rem 1rem 0;
`;
